import { render, staticRenderFns } from "./ModalEditProfiles.vue?vue&type=template&id=0fdb28d6&scoped=true"
import script from "./ModalEditProfiles.vue?vue&type=script&lang=js"
export * from "./ModalEditProfiles.vue?vue&type=script&lang=js"
import style0 from "./ModalEditProfiles.vue?vue&type=style&index=0&id=0fdb28d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb28d6",
  null
  
)

export default component.exports